const CreateOrganizationFormReducer = (state, action) => {
    switch (action.type) {
        case "SET_INPUT":
            return {
                ...state,
                [action.field]: action.payload,
            };
    }
};

export default CreateOrganizationFormReducer;
